import { render } from "./ConversationPage.vue?vue&type=template&id=94e5a61e"
import script from "./ConversationPage.vue?vue&type=script&lang=js"
export * from "./ConversationPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__